import classNames from 'classnames';
import * as React from 'react';
import { TBetPositionTheme } from '../../types';
import * as styles from './Layout.css';

interface ILayoutProps {
  theme: TBetPositionTheme;
  children: React.ReactNode;
}

export const Layout = ({ theme, children }: ILayoutProps) => {
  return <div className={classNames(styles['layout'], styles[theme])}>{children}</div>;
};
